import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-gasket-comp-thickness',
    templateUrl: './gasket-comp-thickness.component.html',
    styleUrls: ['./gasket-comp-thickness.component.scss'],
    standalone: false
})
export class GasketCompThicknessComponent implements OnInit {
    @Input() form: UntypedFormGroup;

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form
            .get('gasketCompThickness')
            .valueChanges.subscribe((value) =>
                this.form.get('gasketCompThickness').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit), { emitEvent: false })
            );
    }
}
